import { ColorPicker } from "../../../../ColorPicker";

type Props = {
  id: string;
  color: string;
  onClose: () => void;
};

export function GroupNodeColorPicker({ id, color, onClose }: Props) {
  return (
    <ColorPicker id={id} color={color} showHexInput={true} onClose={onClose} />
  );
}
